import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import { userProfile } from 'global/Models/userModel';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { setUserLoginBranches, setUserProfile, userHandleLogout } from 'redux/reducer/user/userReducer';
import { AppDispatch } from 'redux/store';
import { userBranches } from '../UserBranches/UserBranchesReducer';

export const getWhoAmI = () => {
  return async (dispatch: AppDispatch) => {
    await ApiService.post(endpointUrls.userWhoAmI, {})
      .then((res: IBackendGetGeneric<userProfile>) =>
        handleApiThenGeneric<IBackendGetGeneric<userProfile>, userProfile>({
          res,
          onSuccessData: (data) => {
            dispatch(setUserProfile(data));
            dispatch(setUserLoginBranches(data.userBranches));
            dispatch(userBranches(data.userBranches));
            localStorage.setItem('username', data.userName);
            localStorage.setItem('branches', JSON.stringify(data.userBranches));
          },
          notifFail: false,
          notifSuccess: false,
          onFailed: () => dispatch(userHandleLogout()),
        })
      )
      .catch(() => {
        localApiCatcher(errorResponse);
        dispatch(userHandleLogout());
      });
  };
};
